
export default {
  name: 'base-header-desktop',
  props: {
    menu: { type: Array, default: () => [] },
    contacts: { type: Array, default: () => [] },
  },
};
